import { SAVE_PERMISSIONS, GET_ROLE_PERMISSIONS, CLIENT_PERMISSIONS } from "../../types";


const permissions = [SAVE_PERMISSIONS, GET_ROLE_PERMISSIONS, CLIENT_PERMISSIONS];
const PermissionReducer = (state = {}, action) => {
    if (permissions.includes(action.type)) return { ...state, [action.type]: action.payload };
    return state;
}

export default PermissionReducer;